let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7mAh9")).then(() => parcelRequire('ahYKy'));